module.exports = require("@pandora/data-model-list");